/**
 * Hook pour scroll automatique vers le haut lors de la navigation
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [pathname]);
}
